import { Alert } from '@lifebit-ai/lds'
import moment from 'moment'
import React from 'react'

import { Result } from 'services/results/types'

import * as styles from './Results.styles'

export const getDate = (date: string) => moment(date).format('MMM DD, YYYY')
export const getTime = (date: string) => moment(date).format('HH:mm:ss')

const getDescription = (result: Result, content?: S3FileAsContent | S3DirAsContent) => {
  if (!result) return null

  const requestDate = getDate(result.createdAt)
  const requestTime = getTime(result.createdAt)

  if (content && !content.isDir && content.lastModified) {
    const updatedDate = getDate(content.lastModified)
    const updatedTime = getTime(content.lastModified)

    return (
      <p>
        You are about to approve a file that was requested on <b>{requestDate}</b> at <b>{requestTime}</b> and last
        modified on <b>{updatedDate}</b> at <b>{updatedTime}</b>. Before approving ensure you have reviewed the latest
        version.
      </p>
    )
  }

  return (
    <p>
      You are about to approve a file that was requested on <b>{requestDate}</b> at <b>{requestTime}</b>. Before
      approving ensure you have reviewed the latest version.
    </p>
  )
}

interface ApprovalModalDescriptionProps {
  isAnalysis: boolean
  result?: Result
  contents?: (S3FileAsContent | S3DirAsContent)[]
}

export const ApprovalModalDescription: React.FC<ApprovalModalDescriptionProps> = ({ result, isAnalysis, contents }) => {
  if (!result) return null
  const content = contents?.[0]

  const APPROVAL_MODAL_DESCRIPTION = `Do you want to approve the request from ${result?.requestingUser?.email} (${
    result?.workspaceName
  }) to export the ${isAnalysis ? 'results' : 'data'}?`

  return (
    <styles.ApprovalModalDescriptionContainer>
      <p>{APPROVAL_MODAL_DESCRIPTION}</p>
      <Alert type="info" showIcon>
        {getDescription(result, content)}
      </Alert>
    </styles.ApprovalModalDescriptionContainer>
  )
}
